import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Hash } from 'lucide-react';
import api from '../lib/api';
import PlanCard from '../components/PlanCard';
import VibePost from '../components/VibePost';

export default function HashtagResults() {
  const { tag } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('plans');

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const { data: res } = await api.get(`/explore/hashtag/${tag}`);
        setData(res);
      } catch {}
      setLoading(false);
    };
    fetch();
  }, [tag]);

  return (
    <div className="content-area animate-fade-in" data-testid="hashtag-page">
      <div className="px-4 pt-5 pb-3 flex items-center gap-3">
        <button onClick={() => navigate(-1)}>
          <ArrowLeft size={24} className="text-[#111111]" />
        </button>
        <div className="flex items-center gap-1.5">
          <Hash size={20} className="text-[#6B8A00]" />
          <h1 className="text-xl font-bold text-[#6B8A00]">{tag}</h1>
        </div>
      </div>

      <div className="px-4 mb-4 flex gap-2">
        {['plans', 'vibes'].map(t => (
          <button
            key={t}
            onClick={() => setTab(t)}
            className={`px-5 py-2 rounded-full text-sm font-medium transition-all ${
              tab === t ? 'bg-[#111111] text-white' : 'bg-[#F1F0EA] text-[#6B6E73] border border-black/[0.06]'
            }`}
          >
            {t.charAt(0).toUpperCase() + t.slice(1)}
          </button>
        ))}
      </div>

      <div className="px-4 pb-4">
        {loading ? (
          <div className="space-y-3">
            {[1, 2, 3].map(i => <div key={i} className="skeleton h-[100px] rounded-2xl" />)}
          </div>
        ) : tab === 'plans' ? (
          <div className="space-y-3">
            {(data?.plans || []).length === 0 ? (
              <p className="text-center text-sm text-[#9B9EA3] py-8">No plans with #{tag}</p>
            ) : (
              data.plans.map(p => <PlanCard key={p.id} plan={p} />)
            )}
          </div>
        ) : (
          <div className="space-y-3">
            {(data?.vibes || []).length === 0 ? (
              <p className="text-center text-sm text-[#9B9EA3] py-8">No vibes with #{tag}</p>
            ) : (
              data.vibes.map(v => <VibePost key={v.id} vibe={v} />)
            )}
          </div>
        )}
      </div>
    </div>
  );
}
